"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isEmptyData(data) {
    if (typeof data === "string") {
        return data.length === 0;
    }
    return data.byteLength === 0;
}
exports.isEmptyData = isEmptyData;
//# sourceMappingURL=isEmptyData.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@aws-crypto/sha256-browser/build/isEmptyData.js
// module id = iyRJ
// module chunks = 0